import { render, staticRenderFns } from "./EditPictures.vue?vue&type=template&id=36124420&"
import script from "./EditPictures.vue?vue&type=script&lang=ts&"
export * from "./EditPictures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports